import React from 'react';
import Papa from 'papaparse';

import {toImportableDate} from './helper';

export function name() {
  return "Thermo Fisher Scientific Sentinel Metal Detection System"
}

export function importDetails() {
  return (
    <ol>
      <li>
        Using the above tool, upload the file extracted from the <strong>{name()}</strong> device and click submit. A converted file will be downloaded for you.
      </li>
      <li>
        Create a Form if one does not exist already. <br/>
        The form should have the following questions:
        <ul>
          <li>
            Report type
            <ul>
              <li>Question type: Text</li>
              <li>Show on setup is checked</li>
            </ul>
          </li>
          <li>
            Line name
            <ul>
              <li>Question type: Text</li>
              <li>Show on setup is checked</li>
            </ul>
          </li>
          <li>
            Product
            <ul>
              <li>Question type: Text</li>
              <li>Show on setup is checked</li>
            </ul>
          </li>
          <li>
            Date Time
            <ul>
              <li>Question type: Date & Time</li>
            </ul>
          </li>
          <li>
            Number
            <ul>
              <li>Question type: Number</li>
            </ul>
          </li>
          <li>
            Event
            <ul>
              <li>Question type: Text</li>
            </ul>
          </li>
          <li>
            Freq kHz
            <ul>
              <li>Question type: Number</li>
            </ul>
          </li>
          <li>
            Phase deg
            <ul>
              <li>Question type: Number</li>
            </ul>
          </li>
          <li>
            Out Phase peak
            <ul>
              <li>Question type: Number</li>
            </ul>
          </li>
          <li>
            In Phase peak
            <ul>
              <li>Question type: Number</li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        In the created form (Or existing form), Select "Import Data" from the drop down menu.
      </li>
      <li>
        When prompted, select the converted file for upload.
      </li>
      <li>
        Ensure that "yyyy-MM-dd HH:mm:ss" is selected for "Import Date Format" and "Not Imported" is selected for "Data Submission date"
      </li>
      <li>
        Ensure that each other field has an assicated input from the drop down. This should be done for you if you created the form using this guide
      </li>
      <li>
        Click "Start Import".
      </li>
    </ol>
  )
}

export function transform(file, onComplete) {
  let beginEvents = false;
  let context = [];
  let headers = [];
  let rows = [];

  Papa.parse(file, {
    worker: true,
    skipEmptyLines: true,
    step: (result, parser) => {
      // Setup Questions
      if (!beginEvents) {
        if (result.data[0].startsWith("Report type:")) {
          headers.push("Report type")
          context.push(result.data[0].split(":")[1].trim());
        }
        else if (result.data[0].startsWith("Line name:")) {
          headers.push("Line name")
          context.push(result.data[0].split(":")[1].trim());
        }
        else if (result.data[0].startsWith("Product:")) {
          headers.push("Product")
          context.push(result.data[0].split(":")[1].trim());
        }
        else if (result.data.length === 1 && result.data[0] === "Events") {
          beginEvents = true;
        }
      }
      // The Row data
      else {
        // Header Row
        if (result.data[0] === "Date/Time") {
          headers = [...headers, ...result.data.map(datum => {
            if (datum.trim() === "#") {
              return "Number"
            }
            return datum.trim().replace(/[^a-z0-9 ]/gi, ' ').replace(/\s\s+/g, ' ');
          })].filter(val => !!val);
        }
        // The rest
        else {
          rows.push([...context, ...result.data.map((value, index) => {
            if (index === 0) {
              return toImportableDate(new Date(value.trim()));
            }
            return value.trim();
          })])
        }
      }
    },
    complete: () => {
      onComplete(headers, rows);
    }
  })
}